/**
 * 主题风格切换*/
import { themeOptions } from '@/assets/js/themes'
import cssVars from 'css-vars-ponyfill'

// 设置主题色
const initTheme = (themeKey = 'r') => {
  const body = document.body
  const theme = themeOptions[themeKey] ? themeOptions[themeKey] : themeOptions.r
  body.style.setProperty('data-theme', themeKey)
  // 实现兼容方案
  cssVars({
    // 添加、删除、修改<link>或<style>元素的禁用或href属性时，ponyfill 将自行调用 
    watch: true,
    // variables 自定义属性名/值对的集合
    variables: theme,
    // false  默认将 css 变量编译为浏览器识别的 css 样式 ；true 当浏览器不支持css变量的时候将css变量编译为识别的css
    onlyLegacy: true,
  })
}

export {
  initTheme
}
